import React, { useEffect, useRef, useState } from 'react';
import {
  Col,
  Row,
  Tabs,
  Tab,
  Card,
  Form,
  Button,
  Table,
  Overlay,
  Popover,
  Spinner,
  ToggleButton,
} from 'react-bootstrap';
import moment from 'moment';

import Layout from '../../wrappers/layout';
import PageHeader from '../../shared/page-header';
import { useHistory } from 'react-router-dom';
import CurrencyInput from 'react-currency-input-field';
// import { Form } from 'formik';
import './styles.css';
import RadioCard from 'pages/signup/components/radioCard';
import Faq from './faq';
import { toast } from 'react-toastify';
import SipHttp from './sip.service';
import { userStore } from 'store/UserStore';
import { formatAmount, makeQuery } from '../../utils';
import BuySellService from '../../services/buy-sell.service';
import { dashboardStore } from 'store/DashboardStore';
import Alert from 'shared/common/alert';
import EmandateList from './EmandateList';
import dashboardService from 'services/dashboard.service';
import SupportButton from 'shared/common/supportButton/SupportButton';
import KYCPopup from 'shared/common/kycPopup';

// import Swal from 'sweetalert2';
interface PropsType {}

const SipPage: React.FC<PropsType> = () => {
  const history = useHistory();
  const [seoSipData, setSeoSipData] = useState([]);
  const [selectedTab, setSelectedTab] = useState<any>('createnewsip');
  const [amountValue, setAmountValue] = useState<any | null>(null);
  const [gramValue, setGramValue] = useState<any | null>(null);
  const [planTime, setPlanTime] = useState('');
  const [metalType, setMetalType] = useState('');
  const [sipButtonFlag, setSipButtonFlag] = useState(true);
  const [SIPList, setSIPList] = useState([]);
  const [isKYCRequired, setIsKYCRequired] = useState(false);
  const [investType, setInvestType] = useState('amount');
  const [customerId, setUser] = userStore((state: any) => [
    state.customerId,
    state.setUser,
  ]);
  const [filter, setFilter] = useState({
    customerId: customerId,
    metal: '',
    frequency: '',
    start_date: '',
    end_date: '',
  });
  const [emandateList, setEmandateList] = useState([]);

  //pricebrkdown
  const targetSell = useRef(null);
  const [isPriceBreakdownShowSell, setIsPriceBreakdownShowSell] =
    useState(false);
  const [loading, setLoading] = useState<any>(false);
  const [itemCode, setItemCode] = useState<any>('');
  const [quoteError, setQuoteError] = useState(false);
  const [priceBreakdown, setPriceBreakdown] = useState(null);
  const [quoteLoading, setQuoteLoading] = useState(false);
  const [user, selectedAccount, customer] = userStore((state: any) => [
    state.user,
    state.selectedAccount,
    state.customer,
  ]);
  const [isActive, setIsActive] = useState(false);
  const [open, setOpen] = useState<any>(false);
  const [statusId, setStatusId] = useState<any>('');
  const [metalRates, setMetalRates] = useState<any>([]);
  let sippassbook = new URLSearchParams(location.search).get('sippassbook');
  // console.log('sippasbook', sippassbook, selectedTab);

  const handleToggle = async (sipid) => {
    try {
      const data = { sip_id: sipid, status: 'INACTIVE', user_id: user?.userId };
      const res = await SipHttp.changeSIPStatus(data);
      if (res?.status == 200) {
        toast.success('SIP deactivated successfully!');
        getSIPList();
      } else {
        toast.error('Something went wrong');
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
    }
  };
  const addquoute = async () => {
    const quotedata = {
      currency: 'INR',
      ebActRef: selectedAccount?.accountId,
      items: [
        {
          itemCode: itemCode,
          otherItems: [],
          requestedType: 'PRODUCT_QTY',
          requestedValue: Number(gramValue),
          requestedValueAmount: null,
          requestedValueQuantity: gramValue,
          uom: 'g',
        },
      ],

      type: 'SELL',
    };
    const resp = await BuySellService.addQuote(quotedata, user?.userId, '');
    setPriceBreakdown(resp.data.data);
    if (resp.data.data?.summary?.quotationTotal > 100000) {
      toast.error('Investment cannot exceed ₹1,00,000 ');
      setSipButtonFlag(true);
    } else {
      setSipButtonFlag(false);
    }
  };
  //---end
  const onChangeTab = (tab) => {
    setSelectedTab(tab);
  };

  const onAmountClick = (value) => {
    setAmountValue(amountValue + value);
  };
  const onGramClick = (value) => {
    setGramValue(Number(gramValue) + Number(value));
  };

  const onSipClick = () => {
    // let gramErr;
    // if (
    //   (gramValue == null && amountValue == null) ||
    //   (amountValue < 100 && gramValue < 1)
    // ) {
    //   return toast.error('Please enter Amount or Quantity');
    // } else if (amountValue > 99999) {
    //   toast.error('Amount should be less than ₹1,00,000');
    //   return setSipButtonFlag(true);
    // } else if (gramValue) {
    //   gramErr = validateGramsforMetal();
    // }
    // if (!gramErr) {
    history.push({
      pathname: '/sip-plan',
      state: {
        sipMetalType: metalType,
        sipAmount: amountValue,
        sipGram: gramValue,
        sipInterval: planTime,
      },
    });
    // }
  };

  const getSIPList = async () => {
    try {
      const resp = await SipHttp.getSIPList(filter, user?.userId);
      if (resp.status == 200) {
        setSIPList(resp?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChangeFilter = async (e: any) => {
    const { name, value } = e.target;

    setFilter({
      ...filter,
      // [name]: name === 'fromDate' || name === 'toDate' ? moment(value).format('DD/MM/yyyy') : value
      [name]: value,
    });
  };

  const getMetalRates = async () => {
    try {
      const res: any = await SipHttp.getMetalRates();
      if (res?.status == 200) {
        setMetalRates(res?.data?.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const validateGramsforMetal = () => {
    // console.log('metalType', metalType);
    let gramErr = true;

    switch (metalType) {
      case 'Ag':
        if (metalType == 'Ag' && (gramValue < 2 || gramValue > 1000)) {
          setSipButtonFlag(true);
          toast.error('Silver should be between 2g to 1kg');
          return gramErr;
        }
      case 'Pt':
        if (metalType == 'Pt' && (gramValue < 1 || gramValue > 20)) {
          setSipButtonFlag(true);
          toast.error('Platinum should be between 1g to 20g');
          return gramErr;
        }

      case 'Pd':
        if (metalType == 'Pd' && (gramValue < 1 || gramValue > 15)) {
          setSipButtonFlag(true);
          toast.error('Palladium should be between 1g to 15g');
          return gramErr;
        }
      case 'Au':
        if (metalType == 'Au' && (gramValue < 1 || gramValue > 10)) {
          setSipButtonFlag(true);
          toast.error('Gold should be between 1g to 10g');
          return gramErr;
        }

      default:
        return false;
      // return setSipButtonFlag(false);
    }
  };

  // const validateGramsforMetal = () => {
  //   switch (metalType) {
  //     case 'Au':
  //       if (
  //         gramValue * metalRates?.gold?.rate < 100 ||
  //         gramValue * metalRates?.gold?.rate > 100000
  //       ) {
  //         setSipButtonFlag(true);
  //         console.log('metalType', metalType, metalRates?.gold?.rate);

  //         return toast.error('Gold should be between 1g to 10g');
  //       }
  //     case 'Pd':
  //       if (
  //         gramValue * metalRates?.palladium?.rate < 100 ||
  //         gramValue * metalRates?.palladium?.rate > 100000
  //       ) {
  //         setSipButtonFlag(true);
  //         console.log('metalType', metalType, metalRates?.palladium?.rate);

  //         return toast.error('Palladium should be between 1g to 20g');
  //       }
  //     case 'Pt':
  //       if (
  //         gramValue * metalRates?.platinum?.rate < 100 ||
  //         gramValue * metalRates?.platinum?.rate > 100000
  //       ) {
  //         setSipButtonFlag(true);
  //         console.log('metalType', metalType, metalRates?.platinum?.rate);

  //         return toast.error('Platinum should be between 1g to 30g');
  //       }
  //     case 'Ag':
  //       if (
  //         gramValue * metalRates?.silver?.rate < 100 ||
  //         gramValue * metalRates?.silver?.rate > 100000
  //       ) {
  //         setSipButtonFlag(true);
  //         console.log('metalType', metalType, metalRates?.silver?.rate);

  //         return toast.error('Silver should be between 2g to 1kg');
  //       }

  //     default:
  //       return setSipButtonFlag(false);
  //   }
  // };

  const setSIPInitialState = async () => {
    // setFilter({
    //   customerId: customerId,
    //   metal: '',
    //   frequency: '',
    //   start_date: '',
    //   end_date: '',
    // });

    setFilter((prevState) => {
      return {
        ...prevState,
        frequency: '',
        customerId: customerId,
        metal: '',
        start_date: '',
        end_date: '',
      };
    });
    // getSIPList();
  };

  const onSuccess = () => {
    // cancelFunction();
    handleToggle(statusId);
    setOpen(false);
  };

  const onCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    getSIPList();
  }, [filter]);

  //@ts-ignore
  useEffect(() => {
    if (
      metalType == '' ||
      planTime == '' ||
      (gramValue == null && amountValue == null) ||
      (amountValue < 100 && gramValue < 1)
    ) {
      setSipButtonFlag(true);
    } else if (amountValue > 100000) {
      toast.error('Amount should be less than ₹1,00,000');
      setSipButtonFlag(true);
    }
    // else if (gramValue) {
    //   validateGramsforMetal();
    // }
    else {
      setSipButtonFlag(false);
    }
  }, [metalType, amountValue, planTime, gramValue]);

  // useEffect(() => {
  //   if (gramValue) {
  //     addquoute();
  //     setIsPriceBreakdownShowSell(true);
  //   }
  // }, [gramValue, metalType]);

  const handleViewClick = async (sip) => {
    try {
      const res: any = await dashboardService.getAllMetals();

      if (res.status === 200 && res.data.data) {
        const response = res?.data?.data?.result;

        const metalMatch = await response?.find(
          (m) => sip?.metal == m?.metalCode
        );

        if (metalMatch) {
          sip['itemCode'] = metalMatch?.itemCode;
          const encodedSip = encodeURIComponent(JSON.stringify(sip));
          history.push(`/sip-payment-schedule/${sip.id}?data=${encodedSip}`);
        } else {
          toast.error('Something went wrong');
        }
        return Promise.resolve(true);
      } else {
        return Promise.reject(false);
      }
    } catch (e: any) {
      console.log(e.message);
      return Promise.reject(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const selectedTabFromQuery = queryParams.get('tab');
    const toastMessage = queryParams.get('toastMessage');
    // Check if the selectedTabFromQuery is 'sippassbook'
    if (selectedTabFromQuery === 'sippassbook') {
      setSelectedTab('sippassbook');
      // Store the selected tab in browser storage
    }
    if (toastMessage) {
      toast.success(decodeURIComponent(toastMessage));
      const newSearch = queryParams.toString().replace('toastMessage', '');
      history.replace({
        search: newSearch,
      });
    }
  }, [history]);

  const checkPanRequirement = async () => {
    try {
      if (!customer?.kyc?.pan?.isVerified) {
        return setIsKYCRequired(true);
      } else {
        onSipClick();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onKycModalClose = () => {
    setIsKYCRequired(false);
  };

  useEffect(() => {
    const seoSip = JSON.parse(localStorage.getItem('sipdata'));
    if (seoSip) {
      setSeoSipData(seoSip);
      setAmountValue(seoSip?.sipAmount);
      setMetalType(seoSip?.sipMetalType);
      setPlanTime(seoSip?.sipInterval);
      setItemCode(seoSip?.sipItemCode);
      localStorage.removeItem('sipdata');
    }
  }, []);

  return (
    <Layout>
      <div className='pb'>
        {/* <PageHeader
          mainTitle='Passbook'
          subTitle='All your transaction details'
          isShowSub={true}
          // isShowSub={selectedTab === 'metalTransactions'}
        /> */}

        <Row>
          <Col md={12}>
            <Tabs
              defaultActiveKey={'createnewsip'}
              activeKey={selectedTab}
              id='uncontrolled-tab-example'
              className='mb-3'
              onSelect={setSelectedTab}
            >
              <Tab eventKey='createnewsip' title='Create New SIP'>
                <div style={{ backgroundColor: 'white' }}>
                  <div className='div-container'>
                    <h2>Create your SIP</h2>
                    <Card className='card-com'>
                      <Card.Body>
                        {/* <Tabs
                defaultActiveKey='SELL'
                id='uncontrolled-tab-example'
                className='mb-3'
                // onSelect={onChangeTab}
              > */}
                        {/* <Tab eventKey='SaveDaily' title='Save Daily'> */}
                        <div className='main-container'>
                          <div>
                            <h6>Frequency</h6>

                            <Form className='radio-div'>
                              <Form.Check
                                type='radio'
                                label='Weekly'
                                name='payment-group'
                                value={'weekly'}
                                onChange={(e) => setPlanTime(e.target.value)}
                                checked={planTime === 'weekly'}
                              ></Form.Check>
                              <Form.Check
                                type='radio'
                                label='Monthly'
                                name='payment-group'
                                value={'monthly'}
                                onChange={(e) => setPlanTime(e.target.value)}
                                checked={planTime === 'monthly'}
                              ></Form.Check>
                            </Form>
                          </div>

                          <h6>Precious Metal Type</h6>
                          <div className='radio-div'>
                            <Form.Check
                              type='radio'
                              label='Silver'
                              name='payment-group'
                              value={'Ag'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              id='Ag0003'
                              checked={metalType === 'Ag'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Gold'
                              value={'Au'}
                              id={'Au00005'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Au'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Platinum'
                              value={'Pt'}
                              id={'Pt00003'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Pt'}
                            ></Form.Check>
                            <Form.Check
                              type='radio'
                              label='Palladium'
                              value={'Pd'}
                              id={'Pd00008'}
                              name='payment-group'
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setItemCode(e.target.id);
                              }}
                              checked={metalType === 'Pd'}
                            ></Form.Check>
                          </div>
                          <div className='sub-container'>
                            <div className='sub1-container'>
                              {/* <h6 className='font-weight-bold'>
                                Select Investment Type
                              </h6> */}

                              <div
                                className='d-flex tg-btns'
                                // style={{ marginBottom: '10px' }}
                              >
                                {/* <ToggleButton
                                  // eslint-disable-next-line react/no-array-index-key
                                  id={`radio-siptype-1`}
                                  type='radio'
                                  name='radio-invest'
                                  variant='outline-warning'
                                  style={{
                                    fontSize: '14px',
                                    width: '100px',
                                    height: '0%',
                                  }}
                                  value={'amount'}
                                  checked={investType === 'amount'}
                                  onChange={(e) => {
                                    setInvestType(e.currentTarget.value);
                                    setGramValue(null);
                                  }}
                                >
                                  Rupees
                                </ToggleButton>
                                <p className='m-2'>OR</p>

                                <ToggleButton
                                  // eslint-disable-next-line react/no-array-index-key
                                  id={`radio-siptype-2`}
                                  type='radio'
                                  name='radio-invest'
                                  variant='outline-warning'
                                  style={{
                                    fontSize: '14px',
                                    width: '100px',
                                    height: '0%',
                                  }}
                                  value={'quantity'}
                                  checked={investType === 'quantity'}
                                  onChange={(e) => {
                                    setInvestType(e.currentTarget.value);
                                    setAmountValue(null);
                                  }}
                                >
                                  Grams
                                </ToggleButton> */}
                                {/* <button
                                  className='btn btn-primary '
                                  style={{
                                    fontSize: '14px',
                                    width: '100px',
                                    height: '0%',
                                  }}
                                  onClick={() => {
                                    setInvestType('amount'), setGramValue(null);
                                  }}
                                  value='Rupees'
                                >
                                  Rupees
                                </button>{' '}
                                <p className='m-2'>OR</p>
                                <button
                                  className='btn btn-primary btn-xs '
                                  style={{
                                    fontSize: '14px',
                                    width: '100px',
                                    height: '0%',
                                  }}
                                  onClick={() => {
                                    setInvestType('quantity'),
                                      setAmountValue(null);
                                  }}
                                >
                                  Grams
                                </button> */}
                              </div>
                              <div className='d-flex justify-content-between'>
                                <h6>{`Enter investment ${investType}`}</h6>
                                {/* <div className=''>
                                  <h6
                                    className='badge custom-badge  p-1 mb-2'
                                    onClick={() => {
                                      investType == 'amount' ? (
                                        <>
                                          {
                                            (setInvestType('quantity'),
                                            setAmountValue(null))
                                          }
                                        </>
                                      ) : (
                                        <>
                                          {
                                            (setInvestType('amount'),
                                            setGramValue(null))
                                          }
                                        </>
                                      );
                                    }}
                                    style={{
                                      color: 'white',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                    }}
                                  >
                                    {investType == 'amount'
                                      ? 'In Grams'
                                      : 'In Rupees'}
                                  </h6>
                                </div> */}
                              </div>
                              {investType == 'amount' ? (
                                <>
                                  <CurrencyInput
                                    // disabled={
                                    //   customer.active === 'DISABLED' ||
                                    //   Object.keys(selectedAccount).length === 0 ||
                                    //   selectedAccount.active === 'DISABLED'
                                    // }
                                    className='text-end form-control'
                                    name='amount'
                                    allowNegativeValue={false}
                                    // value={razorpay.amount}
                                    onWheel={(e: any) => e.target.blur()}
                                    onValueChange={
                                      (value, name) => {
                                        Number(value) > 0
                                          ? setAmountValue(Number(value))
                                          : setAmountValue(Number(null));
                                      }
                                      // onChangeAmount(value, name, true)
                                    }
                                    value={amountValue}
                                    prefix='₹ '
                                    placeholder='₹ 0'
                                    maxLength={6}
                                  />

                                  <span>Minimum SIP amount is ₹ 100</span>
                                </>
                              ) : (
                                <>
                                  {/* <div className='d-flex justify-content-between'>
                                    <Form.Label>Price</Form.Label>
                                    <Form.Label
                                      role='button'
                                      ref={targetSell}
                                      onClick={() =>
                                        setIsPriceBreakdownShowSell(
                                          !isPriceBreakdownShowSell
                                        )
                                      }
                                    >
                                      Price Breakdown
                                    </Form.Label>
                                    <Overlay
                                      target={targetSell.current}
                                      show={
                                        targetSell.current &&
                                        !loading &&
                                        isPriceBreakdownShowSell
                                      }
                                      placement={
                                        window.innerWidth >= 576
                                          ? 'right-start'
                                          : 'top'
                                      }
                                    >
                                      {(props) => (
                                        <Popover
                                          id='popover-basic-sell'
                                          {...props}
                                        >
                                          <Popover.Body>
                                            {!priceBreakdown || quoteLoading ? (
                                              <Spinner
                                                animation='border'
                                                size='sm'
                                              ></Spinner>
                                            ) : (
                                              <div>
                                                <p>
                                                  Rate : <br />
                                                  <strong>
                                                    ₹{' '}
                                                    {formatAmount(
                                                      priceBreakdown.items[0]
                                                        .itemBreakDown[0]
                                                        .summary.unitPrice,
                                                      2
                                                    )}
                                                    /g
                                                  </strong>
                                                </p>
                                                <p>
                                                  Quantity : <br />
                                                  <strong>{`${priceBreakdown.items[0].itemBreakDown[0].qty.toFixed(
                                                    4
                                                  )} g`}</strong>
                                                </p>
                                                {priceBreakdown.items[0]
                                                  .itemBreakDown[0].summary
                                                  .adjustedQuantity !== 0 && (
                                                  <p>
                                                    Product Discount : <br />
                                                    <strong>{`${priceBreakdown.items[0].itemBreakDown[0].summary.adjustedQuantity.toFixed(
                                                      4
                                                    )} g`}</strong>
                                                  </p>
                                                )}
                                                <p>
                                                  Line Amount : <br />
                                                  <strong>
                                                    ₹{' '}
                                                    {formatAmount(
                                                      priceBreakdown.items[0]
                                                        .summary.totalLineAmount
                                                    )}
                                                  </strong>
                                                </p>

                                                {priceBreakdown.summary
                                                  .itemTotalDiscount !== 0 && (
                                                  <p>
                                                    Discount : <br />
                                                    <strong>
                                                      ₹{' '}
                                                      {formatAmount(
                                                        priceBreakdown.summary
                                                          .itemTotalDiscount
                                                      )}
                                                    </strong>
                                                  </p>
                                                )}
                                
                                                {priceBreakdown.summary
                                                  .itemTotalTax !== 0 && (
                                                  <p>
                                                    GST : <br />
                                                    <strong>
                                                      ₹{' '}
                                                      {formatAmount(
                                                        priceBreakdown.summary
                                                          .itemTotalTax
                                                      )}
                                                    </strong>
                                                  </p>
                                                )}
                                                {priceBreakdown.summary
                                                  .quotationTax !== 0 && (
                                                  <p>
                                                    TCS : <br />
                                                    <strong>
                                                      ₹{' '}
                                                      {formatAmount(
                                                        priceBreakdown.summary
                                                          .quotationTax
                                                      )}
                                                    </strong>
                                                  </p>
                                                )}
                                                {priceBreakdown.summary
                                                  .quotationRoundingDifference !==
                                                  0 &&
                                                  (priceBreakdown.summary
                                                    .quotationRoundingDifference >
                                                    0 ||
                                                    priceBreakdown.summary
                                                      .quotationRoundingDifference <
                                                      0) && (
                                                    <p>
                                                      Rounding Difference :{' '}
                                                      <br />
                                                      <strong>
                                                        {priceBreakdown.summary
                                                          .quotationRoundingDifference >
                                                        0
                                                          ? '₹ ' +
                                                            formatAmount(
                                                              priceBreakdown
                                                                .summary
                                                                .quotationRoundingDifference
                                                            )
                                                          : '- ₹ ' +
                                                            formatAmount(
                                                              priceBreakdown
                                                                .summary
                                                                .quotationRoundingDifference *
                                                                -1
                                                            )}
                                                      </strong>
                                                    </p>
                                                  )}
                                                <p className='mb-0'>
                                                  Total : <br />
                                                  <strong>
                                                    ₹{' '}
                                                    {formatAmount(
                                                      priceBreakdown.summary
                                                        .quotationTotal
                                                    )}
                                                  </strong>
                                                </p>
                                              </div>
                                            )}
                                          </Popover.Body>
                                        </Popover>
                                      )}
                                    </Overlay>
                                  </div> */}
                                  <CurrencyInput
                                    // disabled={
                                    //   customer.active === 'DISABLED' ||
                                    //   Object.keys(selectedAccount).length === 0 ||
                                    //   selectedAccount.active === 'DISABLED'
                                    // }
                                    className='text-end form-control'
                                    name='gram'
                                    allowNegativeValue={false}
                                    // value={razorpay.amount}
                                    onWheel={(e: any) => e.target.blur()}
                                    onValueChange={
                                      (value, name) => {
                                        Number(value) > 0
                                          ? setGramValue(value)
                                          : setGramValue(Number(null));
                                      }
                                      // onChangeAmount(value, name, true)
                                    }
                                    value={gramValue}
                                    suffix=' g'
                                    decimalsLimit={4}
                                    decimalScale={4}
                                    placeholder='0.0000 g'
                                  />

                                  <span>Minimum SIP investment is 1g.</span>
                                </>
                              )}
                            </div>
                            <div className='sub2-container'>
                              <Button
                                // variant='outline-warning'
                                size='sm'
                                disabled={sipButtonFlag}
                                onClick={() => checkPanRequirement()}
                                className='Start-An-AIP'
                              >
                                Start SIP
                              </Button>
                            </div>
                          </div>
                          <div className='sub3-container'>
                            {investType == 'amount' ? (
                              <div className='d-flex justify-content-around mb-3 mt-3 tg-btns'>
                                {[100, 500, 1000, 10000].map((amount) => (
                                  <Button
                                    variant='outline-warning'
                                    size='sm'
                                    onClick={(e) => {
                                      onAmountClick(Number(amount));
                                    }}
                                    className='currency'
                                  >
                                    + ₹{amount}
                                  </Button>
                                ))}
                              </div>
                            ) : (
                              <div className='d-flex justify-content-around mb-3 mt-3 tg-btns'>
                                {[1.0, 5.0, 10.0, 25.0].map((gram) => (
                                  <Button
                                    variant='outline-warning'
                                    size='sm'
                                    onClick={(e) => {
                                      onGramClick(Number(gram));
                                    }}
                                    className='currency'
                                  >
                                    + {gram} g
                                  </Button>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        {/* </Tab>  */}
                      </Card.Body>
                    </Card>
                  </div>

                  <div className='faq-container'>
                    <h2 className='faq-heading'>Frequently Asked Questions</h2>
                    <Faq />
                  </div>
                </div>
              </Tab>
              <Tab eventKey='sippassbook' title='SIP Passbook'>
                <div>
                  <Card>
                    <Card.Body>
                      <Row className='align-items-center'>
                        <Col md={3}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>SIP Type</Form.Label>
                            <Form.Select
                              aria-label='Default select example'
                              name='frequency'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.frequency}
                            >
                              <option value=''>Frequency</option>
                              <option value='weekly'>Weekly</option>
                              <option value='monthly'>Monthly</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={3}>
                          <Form.Group className='mb-3' controlId='orderMetal'>
                            <Form.Label>Metal</Form.Label>
                            <Form.Select
                              aria-label='Default select example'
                              name='metal'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.metal}
                            >
                              <option value=''> Metal</option>
                              <option value='Ag'>Silver (Ag)</option>
                              <option value='Au'>Gold (Au)</option>
                              <option value='Pt'>Platinum (Pt)</option>
                              <option value='Pd'>Palladium (Pd)</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>

                        <Col md={2}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>Start Date</Form.Label>
                            <Form.Control
                              type='date'
                              name='start_date'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.start_date}
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                        <Col md={2}>
                          <Form.Group className='mb-3' controlId='orderType'>
                            <Form.Label>End Date</Form.Label>
                            <Form.Control
                              type='date'
                              name='end_date'
                              onChange={(e) => handleChangeFilter(e)}
                              value={filter.end_date}
                              // min={filter.fromDate}
                              // disabled={filter.fromDate === ''}
                            ></Form.Control>
                          </Form.Group>
                        </Col>

                        <Col md={2} className='p-0 pt-2'>
                          <Button
                            onClick={() => getSIPList()}
                            className='mx-2'
                            variant='primary'
                          >
                            Apply
                          </Button>
                          <Button
                            onClick={setSIPInitialState}
                            variant='secondary'
                          >
                            Reset
                          </Button>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  <div className='t-wrap overflow-auto'>
                    <Table
                      className='mb-0 w-100 txn__table'
                      striped
                      hover
                      responsive
                    >
                      <thead>
                        <tr>
                          <th>SIP</th>
                          <th>plan name</th>
                          <th>Metal</th>
                          <th>Frequency</th>
                          <th>start date</th>
                          {/* <th>End Date</th> */}
                          <th>Duration</th>
                          <th>Status</th>
                          <th>Amount</th>
                          <th>E-mandate Status</th>
                          <th>Payment Schedule</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {SIPList?.length > 0 ? (
                          SIPList?.map((sip, index) => (
                            <tr key={index}>
                              <td className=''>{sip?.id}</td>
                              <td>{sip?.planName}</td>
                              <td>
                                {/* {formatAmount(metal.items[0].itemBreakDown[0].qty, 4)}g  */}
                                {sip?.metal}
                              </td>
                              <td className=''>{sip?.frequency}</td>
                              <td>
                                {/* /<div className='badge bg-secondary'>  */}
                                <div className=''>
                                  {moment(sip?.startDate).format('DD-MMM-yyyy')}
                                </div>
                              </td>
                              {/* <td className=''>
                                {' '}
                                <div className=''>
                                  {moment(sip?.endDate).format('DD-MMM-yyyy')}
                                </div>
                              </td> */}
                              <td>{sip?.duration} Months</td>
                              <td>{sip?.status}</td>
                              <td className=''>₹{sip?.installmentAmt}</td>

                              <td className=''>
                                {sip?.mandateStatus ? sip?.mandateStatus : '-'}
                              </td>
                              <td className=''>
                                <Button
                                  variant='primary'
                                  onClick={() => handleViewClick(sip)}
                                  bsPrefix='btn-table'
                                  size='sm'
                                >
                                  View
                                </Button>
                              </td>
                              <td className=''>
                                {/* <Form.Check
                                  type='switch'
                                  id={`custom-switch-${sip?.id}`}
                                  label={
                                    sip?.status == 'ACTIVE'
                                      ? 'Active'
                                      : 'Inactive'
                                  }
                                  checked={
                                    sip?.status == 'ACTIVE' ? true : false
                                  }
                                  onChange={(e) => handleToggle(sip?.id)}
                                  style={{
                                    transform: 'scale(1.2)', // Make the button a little bigger
                                  }}
                                  className={
                                    sip?.status == 'ACTIVE'
                                      ? 'active-toggle'
                                      : 'inactive-toggle'
                                  }
                                /> */}
                                {sip?.status == 'ACTIVE' ? (
                                  <Button
                                    variant='primary'
                                    onClick={() => {
                                      setOpen(true);
                                      setStatusId(sip?.id);
                                    }}
                                    bsPrefix='btn-table'
                                    size='sm'
                                  >
                                    Deactivate
                                  </Button>
                                ) : (
                                  <div className='badge bg-secondary'>
                                    Inactive
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={11}>
                              <div className='m-2 d-flex justify-content-center'>
                                No data to display
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                  <Row>{/* <Col md={12}>{/ Pagination Bar /}</Col> */}</Row>
                </div>
              </Tab>
              <Tab eventKey='emandateList' title='E-Mandates'>
                <div>
                  <EmandateList />
                  <Row>{/* <Col md={12}>{/ Pagination Bar /}</Col> */}</Row>
                </div>
              </Tab>
            </Tabs>
          </Col>
        </Row>
        <SupportButton />
        <Alert
          open={open}
          message='Are you sure you want to deactivate this SIP? Once deactivated, you cannot reactivate it.'
          onSuccess={onSuccess}
          onCancel={onCancel}
        />
        <KYCPopup
          isKYCPopupDisplayed={isKYCRequired}
          isPanVerficationRequired={true}
          closeModal={onKycModalClose}
          hideModal={onKycModalClose}
        />
      </div>
    </Layout>
  );
};

export default SipPage;
